import styled from '@emotion/styled';

export const IconContainer = styled.span`
    position: relative;
    display: inline-flex;
    line-height: 0;
    width: 32px;
    height: 32px;
    align-items: center;
    justify-content: center;
`;
